/** @param {() => void} closeDrawer */
const interceptCloseDrawer = (closeDrawer) => {
    /**
     * @param {any} event
     * @param {"backdropClick" | "escapeKeyDown"} reason
     */
    const closeDrawerIntercepted = (event, reason) => {
        if (reason === 'backdropClick') {
            return;
        }

        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        closeDrawer();
    };
    return closeDrawerIntercepted;
};

export default interceptCloseDrawer;
